<script>

import CommonTableComponent from "@/components/table.vue";
import tableSearch from "@/mixins/tableSearch";
import datetime from "@/mixins/datetime";
import workHistory from "@/mixins/daily_reports/workHistory";

export default {
  name: "ModalWorkHistorySP",
  mixins: [tableSearch, datetime, workHistory],
  components: {
    CommonTableComponent
  },
}
</script>

<template>
  <div class="d-xl-flex">
    <b-modal
      id="modal-work-history"
      title="作業履歴"
      size="xl"
      centered
      title-class="font-18"
      hide-footer
      scrollable
      @show="getData"
    >
      <b-row class="mt-2">
        <b-overlay
          :show="isLoading"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <div>
            <div class="d-flex align-items-baseline mb-2">
              <span class="w-25 text-nowrap fw-bold">作業指示番号</span>
              <span class="fw-bold">{{ workOrderId }}</span>
            </div>
            <div class="d-flex align-items-baseline mb-3">
              <span class="w-25 text-nowrap fw-bold">作業指示名</span>
              <span class="fw-bold">{{ workOrderName }}</span>
            </div>
            <div v-for="workHistory in data" :key="workHistory.id" class="mb-3">
              <div v-if="data.length">
                <div class="d-flex border">
                  <div class="bg-warning p-2 label-custom border-start border-end">{{ headers[0].text }}</div>
                  <div class="p-2 w-75">{{ workHistory.start_datetime}}</div>
                </div>
                <div class="d-flex border border-top-0">
                  <div class="bg-warning p-2 label-custom border-start border-end">{{ headers[1].text }}</div>
                  <div  class="p-2 w-75">{{ getUserName(workHistory) }}</div>
                </div>
                <div class="d-flex border border-top-0">
                  <div class="bg-warning p-2 label-custom border-start border-end">{{ headers[2].text }}</div>
                  <div  class="p-2 w-75">{{ workHistory.remarks }}</div>
                </div>
              </div>
              <div class="mb-3" v-else>
                <div class="text-center">
                  データなし。
                </div>
              </div>
            </div>
            <div class="text-center mt-4">
              <button
                size="md"
                class="btn btn-primary waves-effect waves-light"
                @click="closeModal"
              >
                <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
              </button>
            </div>
          </div>

        </b-overlay>
      </b-row>
    </b-modal>
  </div>
</template>

<style scoped>

.label-custom {
  flex: 0 0 105px;
}
</style>
